<script>
  export let simpleFooter = false;

  import {
    mdiFacebook,
    mdiTwitter,
    mdiGoogle,
    mdiInstagram,
    mdiYoutube,
    mdiChevronDown,
    mdiChevronUp,
    mdiFacebookMessenger,
    mdiEmail,
  } from "@mdi/js";

  const currentYear = new Date().getFullYear();
</script>

<div>
  {#if !simpleFooter}
    <footer class="w-100 bgr-brand-5">
      <div class="container t-white grid-12 d-block d-md-grid gap-5 py-8">
        <div class="col-12 mb-8">
          <img src="images/footer/isologo-mobile.svg" alt="isologo-mobile" />
        </div>

        <div class="col-4 t-size-2 d-none d-md-block">
          <h3 class="t-h6 t-weight-regular mb-8">Contáctanos</h3>
          <p>Lunes a viernes de 8:00am a 5:00pm</p>
          <p>
            <svg
              class="w-5 h-auto t-white mr-1 -mb-1"
              height="100%"
              viewBox="0 0 24 24">
              <path fill="currentColor" d={mdiFacebookMessenger} />
            </svg>
            <a
              class="t-white"
              href="https://www.messenger.com/login.php?next=https%3A%2F%2Fwww.messenger.com%2Ft%2FLineruColombia"
              rel="noopener"
              target="_blank">
              Chatea con nosotros
            </a>
          </p>
          <p>
            <svg
              class="w-5 h-auto t-white mr-1 -mb-1"
              height="100%"
              viewBox="0 0 24 24">
              <path fill="currentColor" d={mdiEmail} />
            </svg>
            <a
              class="t-white"
              href="mailto:servicioalcliente@lineru.com"
              rel="noopener"
              target="_blank">
              servicioalcliente@lineru.com
            </a>
          </p>
          <p>60 (1) 329 9833</p>
        </div>

        <div class="col-4 t-size-2 d-none d-md-block">
          <h3 class="t-h6 t-weight-regular mb-8">Legales</h3>

          <p>
            <a
              class="t-white"
              href="https://www.lineru.com/terminos-y-condiciones/"
              rel="noopener"
              target="_blank">
              Términos y condiciones
            </a>
          </p>
          <p>
            <a
              class="t-white"
              href="https://www.lineru.com/politicas-de-privacidad/"
              rel="noopener"
              target="_blank">
              Políticas de privacidad
            </a>
          </p>
          <p>
            <a class="t-white" href="https://www.lineru.com/politicas-de-seguridad-en-internet/" rel="noopener" target="_blank">
              Políticas de seguridad en internet
            </a>
          </p>
        </div>

        <div class="dropdown t-white d-block d-md-none mb-8">
          <div class="dropdown__item">
            <input
              class="dropdown__input"
              id="footer-mobile-1"
              type="checkbox"
              name="footer-mobile" />
            <label for="footer-mobile-1" class="dropdown__label">
              <div class="dropdown__label__title">Contáctanos</div>
              <div class="dropdown__label__icon">
                <svg viewBox="0 0 24 24" height="100%">
                  <path fill="currentColor" d={mdiChevronDown} />
                </svg>
                <svg viewBox="0 0 24 24" height="100%">
                  <path fill="currentColor" d={mdiChevronUp} />
                </svg>
              </div>
            </label>
            <div class="dropdown__content">
              <div class="dropdown__content__text-wrapper t-size-2">
                <p>Lunes a viernes de 8:00am a 5:00pm</p>
                <p>
                  <svg
                    class="w-5 h-auto t-white mr-1 -mb-1"
                    height="100%"
                    viewBox="0 0 24 24">
                    <path fill="currentColor" d={mdiFacebookMessenger} />
                  </svg>
                  <a
                    class="t-white"
                    href="https://www.messenger.com/login.php?next=https%3A%2F%2Fwww.messenger.com%2Ft%2FLineruColombia"
                    rel="noopener"
                    target="_blank">
                    Chatea con nosotros
                  </a>
                </p>
                <p>
                  <svg
                    class="w-5 h-auto t-white mr-1 -mb-1"
                    height="100%"
                    viewBox="0 0 24 24">
                    <path fill="currentColor" d={mdiEmail} />
                  </svg>
                  <a
                    class="t-white"
                    href="mailto:servicioalcliente@lineru.com"
                    rel="noopener"
                    target="_blank">
                    servicioalcliente@lineru.com
                  </a>
                </p>
                <p>60 (1) 329 9833</p>
              </div>
            </div>
          </div>
          <div class="dropdown__item">
            <input
              class="dropdown__input"
              id="footer-mobile-2"
              type="checkbox"
              name="footer-mobile" />
            <label for="footer-mobile-2" class="dropdown__label">
              <div class="dropdown__label__title">Legales</div>
              <div class="dropdown__label__icon">
                <svg viewBox="0 0 24 24">
                  <path fill="currentColor" height="100%" d={mdiChevronDown} />
                </svg>
                <svg viewBox="0 0 24 24">
                  <path fill="currentColor" height="100%" d={mdiChevronUp} />
                </svg>
              </div>
            </label>
            <div class="dropdown__content">
              <div class="dropdown__content__text-wrapper t-size-2">
                <p>
                  <a
                    class="t-white"
                    href="https://www.lineru.com/terminos-y-condiciones/"
                    rel="noopener"
                    target="_blank">
                    Términos y condiciones
                  </a>
                </p>
                <p>
                  <a
                    class="t-white"
                    href="https://www.lineru.com/politicas-de-privacidad/"
                    rel="noopener"
                    target="_blank">
                    Políticas de privacidad
                  </a>
                </p>
                <p>
                  <a
                    class="t-white"
                    href="https://www.lineru.com/politicas-de-seguridad-en-internet/"
                    rel="noopener"
                    target="_blank">
                    Políticas de seguridad en internet
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>

        <div class="col-4">
          <h3 class="t-h6 t-weight-regular mb-5 mb-md-8 t-size-2 t-md-size-6">
            Síguenos en:
          </h3>

          <div class="d-grid grid-4">
            <a
              class="p-0 t-center bdr-none bgr-brand-5:hover"
              aria-label="Facebook"
              href="https://www.facebook.com/LineruColombia"
              target="_blank">
              <span>
                <svg
                  class="w-5 h-5 d-inline-block t-pink-dark"
                  height="100%"
                  viewBox="0 0 24 24">
                  <path fill="currentColor" d={mdiFacebook} />
                </svg>
              </span>
            </a>

            <a
              class="p-0 t-center bdr-none bgr-brand-5:hover"
              aria-label="Twitter"
              href="https://twitter.com/LineruCo"
              target="_blank">
              <span>
                <svg
                  class="w-5 h-5 d-inline-block t-pink-dark"
                  height="100%"
                  viewBox="0 0 24 24">
                  <path fill="currentColor" d={mdiTwitter} />
                </svg>
              </span>
            </a>

            <a
              class="p-0 t-center bdr-none bgr-brand-5:hover"
              aria-label="instagram"
              href="https://www.instagram.com/lineru_colombia"
              target="_blank">
              <span>
                <svg
                  class="w-5 h-5 d-inline-block t-pink-dark"
                  height="100%"
                  viewBox="0 0 24 24">
                  <path fill="currentColor" d={mdiInstagram} />
                </svg>
              </span>
            </a>

            <a
              class="p-0 t-center bdr-none bgr-brand-5:hover"
              aria-label="youtube"
              href="https://www.youtube.com/user/ZinobeCo"
              target="_blank">
              <span>
                <svg
                  class="w-5 h-5 d-inline-block t-pink-dark"
                  height="100%"
                  viewBox="0 0 24 24">
                  <path fill="currentColor" d={mdiYoutube} />
                </svg>
              </span>
            </a>
          </div>
        </div>
      </div>
    </footer>
  {/if}
  <div class="container d-grid grid-12 gap-2 py-6 align-items-center">
    {#if simpleFooter}
      <div class="col-12 col-md-1 mb-4 align-self-start">
        <img src="images/footer/isologo.svg" alt="isologo" />
      </div>
    {/if}
    <div
      class="col-md-8 t-size-2 mb-6 mb-md-0 {simpleFooter ? 'col-12 col-md-7' : 'col-12 col-md-8'}">
      Usar este sitio implica que usted acepta nuestros
      <a
        class="t-weight-bold t-brand-5 t-brand-5:hover"
        href="https://www.lineru.com/terminos-y-condiciones/">Términos y
        condiciones</a>
      -
      <a
        class="t-weight-bold t-brand-5 t-brand-5:hover"
        href="https://www.lineru.com/politicas-de-seguridad-en-internet/">Políticas
        de privacidad</a>
      - Prohibida su reproducción total o parcial, así como su traducción a
      cualquier idioma sin autorización escrita de su titular. Registrada en
      Colombia - Sur América - Nit 900449259-3. Copyright
      {currentYear}
      <a
        class="t-weight-bold t-brand-5 t-brand-5:hover"
        href="https://zinobe.com"
        rel="noopener"
        target="_blank">Zinobe.com</a>
    </div>
    <div class="col-6 col-md-2 t-center t-md-right mb-1 mb-md-0">
      <a href="https://www.sic.gov.co/" rel="noopener" target="_blank">
        <img
          class="w-8/12 w-sm-6/12 w-md-11/12 w-lg-10/12 w-xl-9/12"
          src="/images/footer/industria-comercio.png"
          alt="Industria y Comercio" />
      </a>
    </div>
    <div class="col-6 col-md-2 t-center t-md-right mb-1 mb-md-0">
      <a href="https://www.zinobe.com">
        <img class="img-fluid" src="/images/footer/zinobe.png" alt="Zinobe" />
      </a>
    </div>
  </div>
</div>
